import React from 'react';
import {
  TableContainer,
  Table,
  TableBody,
  TableRow,
  TableCell,
  Checkbox,
  FormControlLabel,
  Typography,
  Box,
} from '@mui/material';

const DEFAULT_COL_MIN = 140; // px

function AreasTable({ layout, state, onToggle, ariaLabel, colMin = DEFAULT_COL_MIN, getKey }) {
  const cols = React.useMemo(() => Math.max(...layout.map((r) => r.length), 0), [layout]);
  const minWidthPx = cols * colMin;

  return (
    <TableContainer
      component={Box}
      sx={{
        overflowX: 'auto',
        WebkitOverflowScrolling: 'touch',
        maxWidth: '100%',
      }}
    >
      <Table size="small" aria-label={ariaLabel} sx={{ minWidth: minWidthPx }}>
        <TableBody>
          {layout.map((row, rIdx) => (
            <TableRow key={`${ariaLabel}-r${rIdx}`}>
              {row.map((label, cIdx) => {
                if (!label) {
                  return (
                    <TableCell key={`${ariaLabel}-r${rIdx}-c${cIdx}`} sx={{ py: 0.5, pr: 1 }} />
                  );
                }
                const key = getKey ? getKey(rIdx, cIdx, label) : label;
                return (
                  <TableCell
                    key={`${ariaLabel}-r${rIdx}-c${cIdx}`}
                    sx={{ py: 0.5, pr: 1, verticalAlign: 'top', whiteSpace: 'nowrap' }}
                  >
                    <FormControlLabel
                      sx={{ m: 0 }}
                      control={
                        <Checkbox
                          size="small"
                          checked={!!state[key]}
                          onChange={onToggle(key)}
                        />
                      }
                      label={<Typography variant="body2">{label}</Typography>}
                    />
                  </TableCell>
                );
              })}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default React.memo(AreasTable);
